module.exports = __webpack_public_path__ + "static/media/ppe_saf_boo.2f64ba9c.png";